module.exports = __webpack_public_path__ + "static/media/robot.48c8220a.jpeg";